import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-745bafd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skills-list" }
const _hoisted_2 = { class: "skills-title" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "skills-progress-box" }
const _hoisted_5 = { class: "skills-tag-list" }

import {ref} from "vue";
import Skill from "@/models/Skill";
import RepositoryFactory from "@/factories/RepositoryFactory";
import CSection from "@/components/section/CSection.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";
import CSectionOneColumn from "@/components/section/CSectionOneColumn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CMySkills',
  setup(__props) {

const skills = ref<Array<Skill>>([])
const tags = ref<Array<string>>([])

RepositoryFactory
    .default()
    .getSkills()
    .then(data => skills.value = data)

RepositoryFactory
    .default()
    .getTags()
    .then(data => tags.value = data)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSectionOneColumn, {
    class: "skills",
    subtitle: _ctx.$t('my-skills-title'),
    title: _ctx.$t('my-skills-quote'),
    text: _ctx.$t('my-skills-description')
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skill, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "skills-item",
            key: index
          }, [
            _createElementVNode("div", {
              class: "wrapper",
              style: _normalizeStyle(`width: ${skill.value}%`)
            }, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(skill.name), 1),
              _createElementVNode("data", {
                class: "skills-data",
                value: skill.value
              }, _toDisplayString(skill.value) + "%", 9, _hoisted_3)
            ], 4),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "skills-progress",
                style: _normalizeStyle(`width: ${skill.value}%`)
              }, null, 4)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "skills-tag",
            key: tag
          }, _toDisplayString(_ctx.$t(`my-skills-tag-${tag}`)), 1))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["subtitle", "title", "text"]))
}
}

})